// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FastBackwardOutlinedSvg from "@fishx/icons-svg/es/asn/FastBackwardOutlined";
import FishxIcon from '../components/FishxIcon';

var FastBackwardOutlined = function FastBackwardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FastBackwardOutlinedSvg
  }));
};

FastBackwardOutlined.displayName = 'FastBackwardOutlined';
export default React.forwardRef(FastBackwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FastBackwardOutlined.js
// module id = 2672
// module chunks = 0